"use client";

import { TWOU_CREATIVE_APP } from "@2u-landing-pages/constants/applicationNames";
import { useCohesionEvents } from "../hooks/useCohesionEvents";

interface UseCohesionEventsProps {
  lob: string;
  school: string;
  program: string;
  nameOverride?: string;
}

export const UseCohesionEvents = ({ lob, school, program, nameOverride }: UseCohesionEventsProps) => {
  useCohesionEvents(
    lob,
    school,
    program,
    nameOverride || `A/A ${school.toUpperCase()} ${program.toUpperCase()}`,
    TWOU_CREATIVE_APP
  );
  return <></>;
};
